<template>
  <CommonImageViewer
    v-if="showViewer"
    :on-switch="onSwitch"
    :on-close="() => {this.showViewer = false}"
    :url-list="imageList"/>
</template>
<script>

import CommonImageViewer from "./common-image-viewer"
export default {
  name: 'ImageViewer',
  components: {
    CommonImageViewer
  },
  props: {
    refreshList: {
      type: Boolean,
      default: false
    },
    updateLastModifyDate: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      showViewer: false,
      imageList: []
    }
  },
  mounted() {
  },
  methods: {
    previewImage(url){
      this.imageList = url.split(',');
      this.showViewer = true;
    },
    onSwitch(index) {
      if(this.refreshList) {
        const url = this.imageList[index]
        const file= {
          id: url.split('fileId=')[1]
        }
        this.updateLastModifyDate(file)
      }
    }
  },
};
</script>
<style lang="scss">
.el-image-viewer__wrapper{
  z-index: 3000 !important;
}

.el-image-viewer__btn.el-image-viewer__close {
  background-color: #000000 !important;
  top: 45px !important;
}

.el-image-viewer__btn.el-image-viewer__prev, .el-image-viewer__btn.el-image-viewer__next {
  background-color: #000000 !important;
}
</style>
